module.exports = __webpack_public_path__ + "assets/img/Group_299.0cdd64db.png";